'use client';
import { EXIST_LOCAL_STORAGE } from '@/services/constants';
import { isEmpty, setStorage } from '@/services/helperFunctions';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
const ignoredKeys = new Set([
    'Sorting',
    'Ip Address',
    'issuer_search_type',
    'page_no',
    'per_page',
    'sorting_column_sorting_order',
    'test_from',
    'test_to',
    'user_id',
    'status', // already destructured above
    'coupon_from',
    'coupon_to',
    'yield_from',
    'yield_to',
    'maturity_from_year',
    'maturity_to_year',
]);
const SearchFilters = ({
    filterData,
    countryData,
    currencyData,
    min_maturity_year,
    max_maturity_year,
    setFilterCloselist,
    paginationData,
    isMobileView,
    appliedFiltersContainerElement,
    setFilterObj,
}: any) => {
    const [filterList, setFilterList] = useState<any>({});

    useEffect(() => {
        if (isEmpty(filterData)) {
            setFilterList({});
        } else if (filterData.country) {
            let obj = {};
            let countryName = !!countryData && countryData?.data?.filter((country: any) => country?.country_code === filterData.country);
            if (countryName?.length > 0) {
                if (filterData.currency) {
                    const currencyJoin = !!currencyData?.data
                        ? [...currencyData?.data?.remaining, ...currencyData?.data?.top_currencies]
                        : [];
                    const currencyName =
                        !!currencyData && currencyJoin?.filter((currencyJoin: any) => currencyJoin?.currency_code === filterData.currency);
                    obj = cleanFilterList({
                        ...filterList,
                        ...filterData,
                        country: countryName[0]?.country_name,
                        currency: currencyName ? currencyName[0]?.currency_name : '',
                    });
                } else {
                    obj = cleanFilterList({ ...filterList, ...filterData, country: countryName[0]?.country_name });
                }
                setFilterList(obj);
            }
        } else if (filterData.currency) {
            const currencyJoin = !!currencyData?.data ? [...currencyData?.data?.remaining, ...currencyData?.data?.top_currencies] : [];
            const countryName =
                !!currencyData && currencyJoin?.filter((currencyJoin: any) => currencyJoin?.currency_code === filterData.currency);

            if (countryName && countryName?.length > 0) {
                const obj = cleanFilterList({ ...filterList, ...filterData, currency: countryName[0]?.currency_name });
                setFilterList(obj);
            }
        } else {
            const obj = cleanFilterList({ ...filterList, ...filterData });
            setFilterList(obj);
        }
    }, [filterData, countryData, currencyData]);

    useEffect(() => {
        setStorage(EXIST_LOCAL_STORAGE.filtersList, filterList);
    }, [filterList]);

    useEffect(() => {
        if (min_maturity_year && max_maturity_year) {
            const obj = cleanFilterList({ ...filterList, maturity_from_year: min_maturity_year, maturity_to_year: max_maturity_year });
            setFilterList(obj);
        }
    }, [min_maturity_year, max_maturity_year]);

    type FilterObject = Record<string, any>;

    const cleanFilterList = useCallback(
        (object: FilterObject) => {
            const { coupon_from, coupon_to, yield_from, yield_to, maturity_from_year, maturity_to_year, status, callable, ...rest } =
                object;

            // Precompute special values only if the source values are valid
            const derivedFields: FilterObject = {
                Maturity: maturity_from_year && maturity_to_year ? `${maturity_from_year} - ${maturity_to_year}` : undefined,
                Yield: yield_from && yield_to ? `${yield_from}% - ${yield_to}%` : undefined,
                Coupon: coupon_from && coupon_to ? `${coupon_from}% - ${coupon_to}%` : undefined,
                include: status ? 'Inactive' : '',
                callable: callable ? 'Exclude' : '',
            };

            const cleaned: FilterObject = {};

            for (const [key, value] of Object.entries({ ...rest, ...derivedFields })) {
                if (!value || ignoredKeys.has(key)) continue;

                if ((key === 'Yield' || key === 'Coupon') && value === '0% - 30%') continue;

                if (key === 'Maturity' && value === `${min_maturity_year} - ${max_maturity_year}`) continue; // Hides default maturity

                cleaned[key] = value;
            }

            return cleaned;
        },
        [min_maturity_year, max_maturity_year]
    );
    console.log('[min_maturity_year, max_maturity_year]', [min_maturity_year, max_maturity_year]);

    const handleCloseFilter = useCallback(
        (filterListCloseKey: string) => {
            const filter: Record<string, string | boolean> = {
                [filterListCloseKey]: '',
            };

            if (['include', 'status'].includes(filterListCloseKey.toLocaleLowerCase())) {
                filter['status'] = false;
            }

            setFilterCloselist(filter);
            const obj = cleanFilterList({ ...filterList, ...filter });
            setFilterList(obj);
        },
        [filterList]
    );

    const filterListLength = useMemo(() => (filterList ? Object.keys(filterList).length : 0), [filterList]);

    return (
        <>
            <div
                className="d-flex my-2 py-2 px-3 flex-wrap gap-3 align-items-center"
                ref={appliedFiltersContainerElement}
                style={{ borderBottom: '2px solid rgb(153, 173, 202)', backgroundColor: 'rgb(240, 245, 255)', borderRadius: '.4rem' }}
            >
                <div className="d-flex flex-wrap align-items-center gap-3 flex-grow-1">
                    <span className="me-2 my-1 text-sm font-medium" style={{ color: 'rgb(69, 69, 69)' }}>
                        {' '}
                        Search results for :
                    </span>
                    {filterListLength > 0 &&
                        Object.keys(filterList).map((key, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {filterList[key] === '' ? null : (
                                        <div
                                            className={`zoomIn row rounded-5  cursor-pointer ${
                                                isMobileView ? 'me-2' : 'me-0'
                                            } d-flex gap-3  px-lg-0 user-select-none`}
                                            style={{
                                                backgroundColor: '#c8ddfa',
                                                boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
                                            }}
                                            key={index}
                                        >
                                            <div
                                                className={`${
                                                    isMobileView ? 'px-1' : 'px-2'
                                                } pe-1 border bg-dark bg-opacity-10  rounded-5 d-flex`}
                                                style={{ paddingTop: '2.3px', paddingBottom: '2.3px' }}
                                            >
                                                <span
                                                    className="ps-1 text-capitalize fw-bolder text-xs d-inline-block align-self-center"
                                                    style={{ color: '#294772' }}
                                                >
                                                    {key?.replaceAll('_', ' ')}
                                                    {':'}
                                                </span>
                                                <span
                                                    className="ps-1 filter-value-sceener text-sm font-semibold text-truncate d-inline-block align-self-center fw-medium"
                                                    style={{ maxWidth: '250px' }}
                                                >
                                                    {filterList[key] === 'strip' ? 'STRIPS' : filterList[key]}
                                                </span>
                                                <span className="ms-1 d-flex align-items-center p-1 filter-closing-icon rounded-circle">
                                                    <FontAwesomeIcon
                                                        icon={faClose}
                                                        size="sm"
                                                        style={{ height: '14px', width: '18px' }}
                                                        color="#eee"
                                                        onClick={() => {
                                                            handleCloseFilter(key);
                                                        }}
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    <div className="flex-grow-1 d-flex align-items-center justify-content-end gap-1">
                        {/* <FontAwesomeIcon
                            icon={faTerminal}
                            size="1x"
                            className="cursor-pointer"
                            onClick={() => setShowQueryFilters(prev => !prev)}
                            style={{ color: '#294772' }}
                        /> */}
                        {!isMobileView && !!paginationData?.maxPriceDate && (
                            <h1 className="mb-0 px-2 py-1 text-sm fst-italic">
                                Pricing as of {new Date(paginationData?.maxPriceDate).toISOString().substring(0, 10)}
                            </h1>
                        )}
                    </div>
                </div>
            </div>
            {/* <QueryFilter showQueryFilters={showQueryFilters} setShowQueryFilters={setShowQueryFilters} setFilterObj={setFilterObj} /> */}
        </>
    );
};

export default memo(SearchFilters);
